export default "__VITE_ASSET__4bY8zPYs__"